<template>
  <Bar
    :chart-options="finalChartOptions"
    :chart-data="finalChartData"
    :chart-id="chartId"
    :dataset-id-key="datasetIdKey"
    :plugins="plugins"
    :css-classes="cssClasses"
    :styles="styles"
    :class="classes"
  />
</template>

<script>
import { Bar } from 'vue-chartjs/legacy'
import { Chart, registerables } from 'chart.js'

Chart.register(...registerables)

export default {
  name: 'BarChart',
  components: { Bar },
  props: {
    chartId: {
      type: String,
      default: 'bar-chart'
    },
    datasetIdKey: {
      type: String,
      default: 'label'
    },
    width: {
      type: Number,
      default: 400
    },
    height: {
      type: Number,
      default: 400
    },
    cssClasses: {
      default: '',
      type: String
    },
    styles: {
      type: Object,
      default: () => {}
    },
    plugins: {
      type: Object,
      default: () => {}
    },
    chartData: {
        type: Object,
        required: true
      },
    chartOptions: {
      type: Object,
      default: () => {}
    },
    classes: {
      type: String,
      default: "w-full"
    }
  },
  data() {
    return {
    }
  },
  computed: {
    finalChartData() {
      return {...this.chartData}
    },
    finalChartOptions() {
      return {...this.chartOptions}
    },
  }
}
</script>